import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { cn } from '@/lib/utils'

interface SearchBarProps {
  value: string
  onChange: (value: string) => void
  onSearch?: () => void
  placeholder?: string
  autoFocus?: boolean
  className?: string
}

export function SearchBar({ 
  value, 
  onChange, 
  onSearch, 
  placeholder = '지역, 식당 또는 음식으로 검색',
  autoFocus = false,
  className 
}: SearchBarProps) {
  const navigate = useNavigate()
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus()
    }
  }, [autoFocus])

  const handleBack = () => {
    navigate(-1)
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (onSearch) {
      onSearch()
    }
  }

  const handleClear = () => {
    onChange('')
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }

  return (
    <div className={cn("sticky top-0 z-50 bg-white", className)}>
      <form onSubmit={handleSubmit} className="flex items-center h-14 px-4 gap-3">
        <button
          type="button"
          onClick={handleBack}
          className="p-0 bg-transparent border-none cursor-pointer"
        >
          <img 
            src="/icons/icon_back.svg" 
            alt="뒤로가기" 
            className="w-6 h-6"
          />
        </button>

        <div className="flex-1 relative">
          <div className="relative flex items-center">
            <img 
              src="/icons/common_home_search_button.svg" 
              alt="검색" 
              className="absolute left-3 w-5 h-5 pointer-events-none"
              style={{ filter: 'invert(60%)' }}
            />
            <input
              ref={inputRef}
              id="search-input"
              name="search-query"
              type="text"
              value={value}
              onChange={(e) => onChange(e.target.value)}
              placeholder={placeholder}
              autoComplete="search"
              className="w-full h-10 pl-10 pr-10 bg-[#F5F5F5] border-none rounded-lg text-[16px] placeholder:text-[#999999] focus:outline-none"
              style={{ borderRadius: '8px' }}
            />
            {value && (
              <button
                type="button"
                onClick={handleClear}
                className="absolute right-3 p-0 bg-transparent border-none cursor-pointer"
              >
                <div className="w-5 h-5 bg-[#999999] rounded-full flex items-center justify-center">
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M9 3L3 9M3 3L9 9" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                  </svg>
                </div>
              </button>
            )}
          </div>
        </div>
      </form>
    </div>
  )
}